const JeeExamSyllabus = [
  {
    data: [
      { title: "Subject 1", value: "Physics" },
      {
        title: "Syllabus",
        value: [
          "Physics and measurement",
          "Vernier callipers-its use to measure the internal and external diameter and depth of a vessel",
          "Rotational motion",
          "Screw gauge-its use to determine thickness/ diameter of thin sheet/wire.",
          "Thermodynamics",
          "Simple Pendulum-dissipation of energy by plotting a graph between the square of amplitude and time.",
          "Kinematics",
          "Metre Scale - the mass of a given object by the principle of moments.",
          "Work, energy, and power",
          "Young's modulus of elasticity of the material of a metallic wire",
          "Properties of solids and liquids",
          "The surface tension of water by capillary rises and effect of detergents.",
          "Gravitation",
          "Co-efficient of Viscosity of a given viscous liquid by measuring terminal velocity of a given spherical body Laws of motion",
          "Plotting a cooling curve for the relationship between the temperature of a hot body and time",
          "Oscillations and waves",
          "Speed of sound in air at room temperature using a resonance tube",
          "Electronic devices",
          "Specific heat capacity of a given (i) solid and (ii) liquid by method of mixtures.",
          "Kinetic theory of gases",
          "The resistivity of the material of a given wire using a metre bridge",
          "Current electricity",
          "The resistance of a given wire using Ohm's law.",
          "Communication systems",
          "Potentiometer - i) Comparison of emf of two primary cells, (ii) Determination of internal resistance of a cell.",
          "Electromagnetic induction and alternating currents",
          "Resistance and figure of merit of a galvanometer by half deflection method",
          "Magnetic effects of current and magnetism",
          "The focal length of; (i) Convex mirror (ii) Concave mirror, and (ii) Convex lens, using the parallax method",
          "Optics",
          "The plot of the angle of deviation vs angle of incidence for a triangular prism",
          "Electromagnetic waves",
          "Refractive index of a glass slab using a travelling microscope",
          "Atoms and nuclei",
          "Characteristic curves of a p-n junction diode in forward and reverse bias",
          "Electrostatics",
          "Characteristic curves of a Zener diode and finding reverse break down voltage",
          "Dual nature of matter and radiation",
          "Characteristic curves of a transistor and finding current gain and voltage gain",
          "Identification of Diode. LED, Transistor. IC. Resistor. A capacitor from a mixed collection of such items.",
          "Using a multimeter to: (i) Identify the base of a transistor (ii) Distinguish between NPN and PNP type transistor (iii) See the unidirectional of current in case of a diode and an LED. (iv) Check the correctness or otherwise of a given electronic component (diode, transistor, or IC).",
        ],
      },
      { title: "Subject 2", value: "Chemistry" },
      {
        title: "Syllabus",
        value: [
          "Physical Chemistry:",
          "Some basic concepts in chemistry",
          "States of matter",
          "Atomic structure",
          "Chemical bonding and molecular structure",
          "Chemical thermodynamics",
          "Solutions",
          "Equilibrium",
          "Redox reactions and electrochemistry",
          "Chemical kinetics",
          "Surface chemistry",
          "Inorganic Chemistry:",
          "Classification of elements and periodicity in properties",
          "Hydrogen",
          "Block elements (alkali and alkaline earth metals)",
          "P Block elements group 13 to group 18 elements",
          "d- and f – block elements",
          "Co-ordination compounds",
          "Environmental chemistry",
          "General principles and processes of isolation of metals",
          "Organic Chemistry",
          "Purification and characterization of organic compounds",
          "Hydrocarbons",
          "Chemistry in everyday life",
          "Principles related to practical chemistry",
          "Organic compounds containing halogens",
          "Organic compounds containing oxygen",
          "Organic compounds containing nitrogen",
          "Polymers",
          "Some basic principles of organic chemistry",
          "Bio-molecules",
        ],
      },
      { title: "Subject 3", value: "Mathematics" },
      {
        title: "Syllabus",
        value: [
          "Complex numbers and quadratic equations",
          "Differential equations",
          "Matrices and determinants",
          "Binomial theorem and its simple applications",
          "Sets, relations and functions",
          "Sequence and Series",
          "Mathematical induction",
          "Vector algebra",
          "Permutations and combinations",
          "Statistics and probability",
          "Mathematical reasoning",
          "Trigonometry",
          "Limit, continuity, and differentiability",
          "Coordinate geometry",
          "Integral calculus",
          "Three-dimensional geometry",
        ],
      },
      { title: "Subject 1", value: "Physics" },
      {
        title: "Books",
        value: [
          "Concepts of physics (Vol. 1 and 2) by H.C Verma",
          "Fundamentals of Physics by Halliday, Resnick & walker",
          "Understanding Physics by D C Pandey (Arihant Publications)",
          "Problems in General Physics by I.E Irodov",
          "Understanding physics by Freedman and Young",
          "Problems in physics by SS Krotov",
          "Problems and solution of physics by Shashi bhushan Tiwari",
          "Fundamentals of Mechanics and Fundamentals of Electrodynamics by Irodov",
          "Advanced Physics by Nelson & Parker",
        ],
      },
      { title: "Subject 1", value: "Chemistry" },
      {
        title: "Books",
        value: [
          "NCERT Textbooks (for Class XI and XII )",
          "Modern Approach to Chemical Calculations by R.C. Mukherjee",
          "Organic Chemistry by O P Tandon",
          "Concept of Physical Chemistry by P Bahadur",
          "Concise Inorganic Chemistry by J D Lee",
          "Physical Chemistry by P.W. Atkins",
          "Organic Chemistry by Morrison & Boyd",
        ],
      },

      { title: "Subject 2", value: "Mathematics" },
      {
        title: "Books",
        value: [
          "NCERT Textbooks (for Class XI and XII )",
          "Objective Mathematics by R D Sharma",
          "Plane Trigonometry by S L Loney",
          "The Elements Of Coordinate Geometry by S L Loney",
          "Algebra by Dr S K Goyal Arihant Publications",
          "Play with Graphs by Amit M Agarwal (Arihant Publications)",
          "Differential Calculus by Amit M Agarwal (Arihant Publications)",
          "Integral Calculus by Amit M Agarwal (Arihant Publications)",
          "Complete mathematics for JEE Main TMH",
        ],
      },
    ],
  },
];

export default JeeExamSyllabus;
